import { render, staticRenderFns } from "./OCKurukuru.html?vue&type=template&id=ba8c0a54&scoped=true&"
import script from "./OCKurukuru.ts?vue&type=script&lang=ts&"
export * from "./OCKurukuru.ts?vue&type=script&lang=ts&"
import style0 from "./OCKurukuru.css?vue&type=style&index=0&id=ba8c0a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8c0a54",
  null
  
)

export default component.exports